(ns practitest.frontend.common-old-fe.logging
  (:require
    [goog.userAgent :as agent]))

(defn- log* [severity args]
  (when-not agent/EDGE_OR_IE
    (when-let [m (aget js/console (name severity))]
      (apply m (if ^boolean goog.DEBUG args (map clj->js args))))))

(defn debug [& args]
  (log* :debug args))

(defn info [& args]
  (log* :info args))

(defn warn [& args]
  (log* :warn args))

(defn error [& args]
  (log* :error args))
